import {changePudoAddress, loadPudoSavedAddressesSuccess, updateSelectedCollectionPointSuccess} from '../pudo-actions';
import {setCollectionCollectorName} from './setCollectionCollectorName';

export const updateCollectionCollectorName = (name, value) => (dispatch, getState) => {
  dispatch(setCollectionCollectorName(value));
  const savedAddress = getState().pudo?.savedAddresses[0];
  
  const point = {
    ...savedAddress,
    name: value,
  };
  
  if (savedAddress) {
    dispatch(updateSelectedCollectionPointSuccess(point, 0));
    dispatch(changePudoAddress(point, 0));
    dispatch(loadPudoSavedAddressesSuccess());
  }
};
